import * as memoizee from 'memoizee';
// Memoize デコレータ
export var Memoize = function (_target, _propertyKey, descriptor) {
    if (descriptor.value) {
        descriptor.value = memoizee(descriptor.value);
    }
    return descriptor;
};
